import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import AlertBox from "../../component/AlertBox";
import { ApplicantDetails } from "./SingleJobApplicant";
import {
  CircularProgress,
  LinearProgress,
  Step,
  StepButton,
  Stepper,
} from "@mui/material";
import DialogBox from "../../component/DialogBox";
import ButtonCompo from "../../component/ButtonCompo";
import InputField from "../../component/InputField";
import AlertDialogBox from "../../component/AlertDialogBox";

function SingleJobApplicantManager() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  // redirect to employee dashboard if permission is not given
  // accessable to "talentAquisation" and "hiringReq"
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.hiringReq === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const { applicantId } = useParams();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [applicantData, setApplicantData] = useState(undefined);
  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [roundDesc, setRoundDesc] = useState("");
  const [reload, setReload] = useState(false);
  const [managerialRoundData, setManagerialRoundData] = useState(undefined);
  const [deleteOpen, setDeleteOpen] = useState(false);

  function stepTransformArray(data, hrConfirmation) {
    let stepArr = [];
    let calcActiveStep = 0;
    const rawData = data;
    if (
      Array.isArray(rawData?.passedInterviewRounds) &&
      rawData?.passedInterviewRounds.length > 0
    ) {
      stepArr = rawData?.passedInterviewRounds.map((item) => {
        return {
          name: item?.desc,
          isCompleted: true,
        };
      });
    }
    stepArr.push({
      name: rawData?.currentInterviewRound?.desc,
      isCompleted: rawData?.currentInterviewStatus === "Hold" ? false : true,
      isRejected: rawData?.currentInterviewStatus === "Rejected" ? true : false,
    });
    stepArr.push({
      name: "Final Discussion",
      isCompleted: hrConfirmation === "Hold" ? false : true,
      isRejected: hrConfirmation === "Rejected" ? true : false,
    });
    // -1 beacuse, to make it 0 based index
    if (rawData?.currentInterviewStatus === "Hold") {
      calcActiveStep = rawData?.currentInterviewRound?.round - 1;
    } else if (
      rawData?.currentInterviewStatus === "Passed" &&
      hrConfirmation === "Hold"
    ) {
      // 1 for current screening round and 1 for final discussion round
      calcActiveStep = rawData?.passedInterviewRounds?.length + 1;
    }
    console.log(rawData?.passedInterviewRounds);
    console.log(stepArr);
    console.log(calcActiveStep);
    setSteps(stepArr);
    setActiveStep(calcActiveStep);
  }

  // fetch single applicant data
  async function getApplicantData() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisition/job/applicant/get/single/applicant/${applicantId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setApplicantData(res.data?.data || null);
      setManagerialRoundData(res.data?.data?.managerialRound || undefined);
      if (res.data?.data?.managerialRound !== undefined) {
        stepTransformArray(
          res.data?.data?.managerialRound,
          res.data?.data?.hrConfirmation
        );
      }
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Hiring request fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // increase round
  async function increaseRound() {
    if (roundDesc === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Please enter round description");
      return;
    }
    const data = {
      roundDocId: managerialRoundData?._id,
      roundDesc: roundDesc,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/hiring/req/managerial/round/shortlisted/applicant/increase`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      console.log(res.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Round increased successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Round increase failed");
    } finally {
      setLoading(false);
    }
  }

  // send to final discussion
  async function sendToFinalDiscuss() {
    if (roundDesc === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Please enter round description");
      return;
    }
    const data = {
      roundDocId: managerialRoundData?._id,
      firstFinalRoundDesc: roundDesc,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/hiring/req/managerial/round/to/final/discussion`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      console.log(res.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Applicant send to final discussion successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Applicant send to final discussion failed");
    } finally {
      setLoading(false);
    }
  }

  async function managerialRoundReject() {
    console.log(managerialRoundData?._id)
    const data = {
      roundDocId: managerialRoundData?._id,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/hiring/req/managerial/round/reject/applicant`,
        method: "delete",
        withCredentials: true,
        data: data,
      });
      console.log(res.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Applicant rejected successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Applicant rejected failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getApplicantData();
  }, [reload]);

  if (applicantData === null) {
    return (
      <div className="text-center mt-5 text-slate-500 font-semibold">
        No data found
      </div>
    );
  }

  if (applicantData === undefined) {
    return (
      <div className="w-full h-[100vh] flex justify-center items-center">
        <CircularProgress size={40} />
      </div>
    );
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <AlertDialogBox
        open={deleteOpen}
        setOpen={setDeleteOpen}
        closeActionButton={"Cancel"}
        actionButton={
          <ButtonCompo onClick={managerialRoundReject} color={"error"}>
            Reject
          </ButtonCompo>
        }
      >
        <p>
          The applicant will be shown as rejected to every round. Are you still
          want to reject the applicant?
        </p>
      </AlertDialogBox>
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <ApplicantDetails
            applicantData={applicantData}
            reqLink={`/admin/hiring/req/single/request/${applicantData?.hiringReq?._id}`}
          />
          <div className="mt-5 shadow-lg rounded-lg">
            <section className="p-5 bg-blue-50/80 rounded-t-lg">
              <h2 className="text-[18px] text-slate-700 font-medium">
                Interview Rounds
              </h2>
            </section>
            <div className="p-5">
              {managerialRoundData !== undefined ? (
                <div className="p-5">
                  <Stepper nonLinear activeStep={activeStep}>
                    {steps.map((step, index) => (
                      <Step key={index} completed={step.isCompleted}>
                        <StepButton color="inherit">
                          <p
                            className={
                              step.isRejected === true
                                ? "text-red-500 font-medium text-[15.7px]"
                                : " font-medium text-[15.7px]"
                            }
                          >
                            {step.name}
                          </p>
                        </StepButton>
                      </Step>
                    ))}
                  </Stepper>
                  {managerialRoundData?.currentInterviewStatus === "Hold" && (
                    <section className="mt-[3rem] flex justify-end items-center gap-5">
                      <DialogBox
                        trigger={
                          <ButtonCompo variant={"contained"}>
                            Add Next Interview Step
                          </ButtonCompo>
                        }
                        title="Add Next Interview Step"
                        actionButton={
                          <ButtonCompo onClick={increaseRound}>
                            Save Changes
                          </ButtonCompo>
                        }
                      >
                        <div>
                          <InputField
                            label="Round Title"
                            onChange={(eve) => setRoundDesc(eve?.target?.value)}
                          />
                          <p className="text-slate-500 mt-3">
                            Please be careful in this step. You can't edit or
                            delete this step later.
                          </p>
                        </div>
                      </DialogBox>
                      <DialogBox
                        trigger={
                          <ButtonCompo variant={"contained"} color={"success"}>
                            Passed & Proceed To Final Discussion
                          </ButtonCompo>
                        }
                        title="Proceed To Final Discussion"
                        actionButton={
                          <ButtonCompo onClick={sendToFinalDiscuss}>
                            Save Changes
                          </ButtonCompo>
                        }
                      >
                        <div>
                          <InputField
                            label="Round Title"
                            onChange={(eve) => setRoundDesc(eve?.target?.value)}
                          />
                          <p className="text-slate-500 mt-3">
                            Please be careful in this step. You can't edit or
                            delete this step later.
                          </p>
                        </div>
                      </DialogBox>
                      <ButtonCompo
                        variant={"contained"}
                        color={"error"}
                        onClick={() => setDeleteOpen(true)}
                      >
                        Reject
                      </ButtonCompo>
                    </section>
                  )}
                </div>
              ) : (
                <div className="text-center text-slate-500 font-medium">
                  No data found
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleJobApplicantManager;
